export const sources = {
	webp: "__VITE_ASSET__Ngmgj7KrmSrUoXH_NFNtFA__ 500w, __VITE_ASSET__eBB5uVE_t2Bb1etqpZE3Ig__ 800w, __VITE_ASSET__cLLFq7OX38PQjR0WE41fig__ 1080w, __VITE_ASSET__2h$eqWdLjjj$zuUvyPi$HQ__ 1092w"
};
export const img = {
	src: "__VITE_ASSET__2h$eqWdLjjj$zuUvyPi$HQ__",
	w: 1092,
	h: 844
};
export default {
	sources: sources,
	img: img
};
